export default __webpack_public_path__ + "static/media/image 9.6e3df0dd.svg";